/* eslint 'jsx-a11y/alt-text': 'off' */
import React, { Component } from 'react';
import {GetWorkorderDetails,PostAttachment,AddWorkOrderAttachments,DeleteWorkOrderAttachment,SaveAttachmentToFolder,DeleteAttachment,DownloadAttachment} from '../../../../action/workorderAction';
import { Col, FormGroup, Label, Form, Table } from 'reactstrap';
import { connect } from "react-redux";
import DeleteIcon from '../../../../Assets/images/Icons__trash2.svg';
import { Icon } from 'semantic-ui-react';

class Attachment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reRender: false,
            displayImageError:false,
            errorImageName:null,
            errorImageText:" file type not supported",
        }
        this.AddAttachment = this.AddAttachment.bind(this);
        this.DeleteAttachment = this.DeleteAttachment.bind(this);
        this.AttachmentDownload = this.AttachmentDownload.bind(this);
    }  

    componentWillMount(){
        console.log(this.props.WOTaskID);
        this.props.GetWorkorderDetails(this.props.WOTaskID);
    }

    AddAttachment(e) {
        e.preventDefault();

        this.setState({
            displayImageError:false,
            errorImageName:null,
            errorImageText:" file size limit exceeded.",
        });

        var fileTypes = ['doc','docx','jpg','jpeg','png','pdf'];
        if (e.target.files && e.target.files[0]) {
            var extension = e.target.files[0].name.split('.').pop().toLowerCase(),  //file extension from input file
            fileTypeSuccess = fileTypes.indexOf(extension) > -1;  //is extension in acceptable types
            var fileSize = document.getElementById('myfile').files[0].size; //Checking for file size
            if (fileTypeSuccess && fileSize <= 25000000 ) {
                let reader = new FileReader();
                let file = e.target.files[0];

                reader.onloadend = () => {
                    const data = new FormData();
                    data.append('file', file);
                    const l_Request = this.props.SaveAttachmentToFolder(data, 0);
                    l_Request.then((result) => {
                        if (this.props.getUniqueAttachmentName !== undefined && this.props.getUniqueAttachmentName !== null && this.props.getUniqueAttachmentName !== []) {
                            var lineitem = {
                                "WorkOrderAttachmentID": 0, "AttachmentName":file.name, "FileName":this.props.getUniqueAttachmentName.FileName
                            }
                            this.props.AddWorkOrderAttachments(lineitem, this.props.WOTaskID);
                        }
                    });
                }

                reader.readAsDataURL(file);
            }
            else if(fileSize >= 25000000) { 
                this.setState({
                    displayImageError:true,
                    errorImageName:e.target.files[0].name,
                    errorImageText:" file size limit exceeded.",
                })
            }
            else  { 
                this.setState({
                    displayImageError:true,
                    errorImageName:e.target.files[0].name,
                    errorImageText:" file type not supported.",
                })
            }
        }
    }

    DeleteAttachment(id, name) {
        let lineitem = {
            "AttachmentId": id,
            "FileName": name,
        }
        let deletePromise = new Promise((resolve) => {
            this.props.DeleteWorkOrderAttachment(this.props.WOTaskID, id);
            resolve();
        });
        deletePromise.then(() => {
            this.props.DeleteAttachment(lineitem);
            this.forceUpdate();
        });
    }

    AttachmentDownload(fileName){
        this.props.DownloadAttachment(fileName);
    }

    render(){
        let label = this.props.getLabels;
        let error_record = null;

        error_record = <tr>
                            <td width="100%"><Icon name='exclamation triangle'style={{marginRight:'1px',padding:'0px',color:'#D42D27'}}/>{" An error has occurred. "}{this.state.errorImageName}{this.state.errorImageText}</td><td></td>
                       </tr>

        var Attachment_Table 

        if(this.props.getDetails.WorkOrderDetails.workOrderAttachment !== undefined && this.props.getDetails.WorkOrderDetails.workOrderAttachment.length > 0){
            Attachment_Table = this.props.getDetails.WorkOrderDetails.workOrderAttachment.map(el => (
                <tr>
                    <td className="link_cursorUnderline" style={{ "width" : "90%", "word-wrap" : "break-word" }} onClick={() => {this.AttachmentDownload(el.fileName)}}>{el.attachmentName}</td>            
                    <td width="10%"><img src={DeleteIcon} className="Ensemble_Icon link_cursor" style={{ valign: 'bottom',width:'15px', height:'14px' }} onClick={() => { this.DeleteAttachment(el.workOrderAttachmentID,el.fileName) }} /></td>
                </tr>
            ));
        }
        else{
            Attachment_Table = <tr><td className="workorderlbl-noentry">{"No attachments"}</td><td>{" "}</td></tr>
        }

        return(
            <Form>
                <FormGroup row>
                    <Col sm={{ size: 9 }}>
                        <div style={{width:'85%'}}>
                            <Label className="workorderlbl">{label['WorkOrders.Heading.Attachments.Text']}</Label>
                            <Label className="workorderedit-choosebtn"  style={{float:'right'}}>
                                <input type="file" id="myfile" onChange={(e) => {this.AddAttachment(e); e.target.value=null}} />{label['WorkOrderEdit.ChooseFile.Text']}
                            </Label>
                        </div>
                    </Col>
                    <Col sm={{ size: 9 }}>
                        <Table responsive className="attachmentTable" style={{width:"85%"}}>
                            <tbody>
                                 <tr><th width="90%">ATTACHMENTS</th><th width="10%">{" "}</th></tr>
                                    {Attachment_Table}  
                                    {(this.state.displayImageError) ? error_record : null }
                            </tbody>
                        </Table>
                        <Label className="workorderlbl-noentry">{label['WorkOrderEdit.FileTypes.Text']}</Label>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

const mapStateToProps = state => {
    return {
        getDetails: state.WorkorderRootReducer,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getUniqueAttachmentName: state.WorkorderRootReducer.UniqueAttachmentName
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetWorkorderDetails: (WorkOrderID) => dispatch(GetWorkorderDetails(WorkOrderID)),
        PostAttachment: (data) => dispatch(PostAttachment(data)),
        AddWorkOrderAttachments: (data, id) => dispatch(AddWorkOrderAttachments(data, id)),
        DeleteWorkOrderAttachment: (WOID,id) => dispatch(DeleteWorkOrderAttachment(WOID,id)),
        DeleteAttachment: (lineitem) => dispatch(DeleteAttachment(lineitem)),
        DownloadAttachment: (data) => dispatch(DownloadAttachment(data)),
        SaveAttachmentToFolder: (file, AttachmentId) => dispatch(SaveAttachmentToFolder(file, AttachmentId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Attachment)